/**
 * @ngdoc services
 * @memberof mercury.services
 * @name throttleInterceptor
 * @description
 *    HTTP interceptor service to limit the number of concurrent requests and queue up any additional requests.
 *    Adapted from https://github.com/mikepugh/angular-http-throttler
 */
angular.module('mercury.services.throttleinterceptor')
.factory('httpThrottler', ["$q", "httpBuffer", "settings", function($q, httpBuffer, settings) {
    var maxConcurrentRequests = 10;
    var singletonRequestMatchers = [
      '/time-clockins',
      '/manual-pos-sale-headers'
    ].map(function(path) {
      return new RegExp(settings.mercHost + path);
    });

    this.maxConcurrentRequests = function(val) {
      maxConcurrentRequests = val || maxConcurrentRequests;
      return maxConcurrentRequests;
    };

    var reqCount = 0;

    var increment = function(config) {
      reqCount++;
      return config || $q.when(config);
    };

    var decrement = function() {
      reqCount--;
      httpBuffer.retryOne();
    };

    var isSingleton = function(url) {
      return singletonRequestMatchers.some(function(requestMatcher) {
        return requestMatcher.test(url);
      });
    };

    function request(config) {
      var deferred;

      // defer the request if we're over our maximum allowed requests, or
      // if the url we're requesting matches one of the singleton request
      // rules and there is already a request in flight, make sure that is
      // the only request
      var shouldDefer = (reqCount >= maxConcurrentRequests) || (isSingleton(config.url) && reqCount > 0);

      if (shouldDefer) {
        deferred = $q.defer();
        httpBuffer.append(config, deferred);
        return deferred.promise.then(function() {
          return request(config);
        });
      } else {
        return increment(config);
      }
    }

    function response(response) {
      decrement();
      return response || $q.when(response);
    }

    function responseError(rejection) {
      decrement();
      return $q.reject(rejection);
    }

    return {
      request: request,
      response: response,
      responseError: responseError
    };
  }]);
